export function isExternal(url) {
  return !!(
    !url.match(/^https?:\/\/[^/]*groovehq\.(com)|(docker)/) &&
    url.match(/^https?:\/\//)
  )
}

const slugifyAccents = 'àáäâèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
const slugifyTransliterated = 'aaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
const slugifyPattern = new RegExp(slugifyAccents.split('').join('|'), 'g')

export function slugify(str) {
  return str
    .toString()
    .toLowerCase()
    .replace(/(\s|%20)+/g, '-') // Replace spaces with -
    .replace(slugifyPattern, c =>
      slugifyTransliterated.charAt(slugifyAccents.indexOf(c))
    ) // Replace special chars
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
}
